import React from "react";
import AllClientsParent from "../../page-components/All Clients/AllClientsParent";
//test
function AllClient() {
  return( <AllClientsParent />)
}

export default AllClient;
